import { useTranslation } from 'react-i18next';

import AmbientHint from '../AmbientHint/AmbientHint';

interface SchoolAdminHintProps {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
}

const SchoolAdminHint = ({ anchorEl, open, onClose }: SchoolAdminHintProps) => {
	const { t } = useTranslation();

	return (
		<AmbientHint
			anchorEl={anchorEl}
			open={open}
			placement="bottom-end"
			title={t('You are now an admin of your school licence!')}
			body={t('In the admin area you can now invite and manage teachers.')}
			onClose={onClose}
		/>
	);
};

export default SchoolAdminHint;
